import config from "../../../../config";
import React from "react";
import { formatDateForLists } from "../../../../utils/formatDateForLists";

export default function SingleRow(props){

    const { bid, auctionData } =props;

    return(
        <tr className="border-b border-[#DEDEDE]" >
            <td className=" text-[#343434]  px-5 py-3 text-[14px] leading-normal font-medium ">
                {bid.lot_number}</td>
            <td><img  
                src={bid.lot_image==="" ? "/images/img-lotlist.png" : 
                    `${config.Storage.CDN}${bid.lot_image}`}
                className="my-3 w-[95px] h-[77px]" alt="img"/></td>
            <td className=" text-[#343434] px-4 py-3 text-[14px]  leading-normal font-medium" 
                // onClick={()=>Navigate(`/auctions/${id}/lots/view/${lot.lot_number}`, { state: isSocket})}
            >
                {bid.lot_title.length > 20 ? bid.lot_title.substring(0, 20) + '...' : bid.lot_title}</td>
            <td className=" text-[#343434] px-5 py-3 text-[14px]  leading-normal font-medium">
                {bid.paddle_number===""  ? '-' : bid.paddle_number}
            </td>
            <td className=" text-[#343434] px-5 py-3 text-[14px]  leading-normal font-medium">
                {bid.name===""  ? '-' : (bid.name.length > 20 ? bid.name.substring(0, 20) + '...' : bid.name)}
            </td>
            <td className=" text-[#343434] px-5 py-3 text-[14px]  leading-normal font-medium">
                <span className={` px-4 py-2 rounded-[42px] ${(bid.bid_status==="Winning" || bid.bid_status==="Won")  ? 
                    "bg-[#A8D9C8] text-[#489892]" : 
                    ( bid.bid_status==="UnderBidder" ? "bg-[#E3C79D] text-[#B98B47] " : "bg-[#E6E6E6] text-[#52525A]" )}`} >
                    {bid.bid_status==="UnderBidder" ? "Underbidder" : bid.bid_status}</span>
            </td>
            <td className=" text-[#343434] px-5 py-3 text-[14px]  leading-normal font-medium truncate max-w-[170px]"
                title={(bid.bid_amount===0 || bid.bid_amount===undefined) ? "-" : 
                    Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                        style: 'currency',
                        currency: auctionData.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })} >
                {(bid.bid_amount===0 || bid.bid_amount===undefined) ? "-" : 
                    Number(bid.bid_amount).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                        style: 'currency',
                        currency: auctionData.currency,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })}
            </td>
            <td className=" text-[#343434] px-5 py-3 text-[14px]  leading-normal font-medium">
                {bid.time_stamp ? (bid.time_stamp==="" ? '-' : 
                    formatDateForLists(bid.time_stamp, auctionData.time_zone)) : '-'}</td>
        </tr>
    )
}